/**
 * @license Copyright (c) 2017-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import $ from 'jquery';

export default function sampleCode() {
	const buttons = document.querySelectorAll( '.sdk-sample-source-code__button' );
	const headerHeight = document.querySelector( 'header.top' ).offsetHeight;

	if ( !buttons ) {
		return;
	}

	// accordion toggling button
	$( '.sdk-sample-source-code__button' ).on( 'click', function( e ) {
		e.preventDefault();

		$( this ).toggleClass( 'active' );
		$( this ).next().toggleClass( 'active' );

		// scroll smoothly to the clicked content
		$( 'html, body' ).animate( {
			scrollTop: $( this).offset().top - headerHeight - 20
		}, 400 );
	} );

	$( '.sdk-sample-source-code__code-block-copy' ).on( 'click', function( e ) {
		const range = document.createRange();
		const sampleCodeEl = this.parentNode.nextElementSibling;

		e.preventDefault();

		range.selectNode( sampleCodeEl );

		// If something is already copied, remove selection.
		window.getSelection().removeAllRanges();

		window.getSelection().addRange( range );
		document.execCommand( 'copy' );

		// Clear selection.
		window.getSelection().removeAllRanges();
		this.textContent = 'Copied!';

		setTimeout( () => {
			this.textContent = 'Copy';
		}, 2000 );
	} );

	$( '.sdk-sample-source-code__code-block-download' ).on( 'click', function( e ) {
		e.preventDefault();

		const sampleCodeText = this.parentNode.nextElementSibling.textContent;

		download( sampleCodeText, 'index.html', 'text/html' );
	} );

	function download( data, filename, type ) {
		var file = new Blob( [ data ], { type: type });
		if ( window.navigator.msSaveOrOpenBlob ) // IE10+
			window.navigator.msSaveOrOpenBlob(file, filename);
		else { // Others
			const a = document.createElement( 'a' );
			const url = URL.createObjectURL( file );

			a.href = url;
			a.download = filename;
			document.body.appendChild( a );
			a.click();
			setTimeout( function() {
				document.body.removeChild( a );
				window.URL.revokeObjectURL( url );
			}, 0 );
		}
	}
}
